/**
 * formatters.ts - Number/string formatting utilities
 */

export function formatSp(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
  return n.toString();
}

export function formatNumber(n: number): string {
  return formatSp(n);
}
